// extracted by mini-css-extract-plugin
export default {"LogoutButton_basic":"LogoutButton_LogoutButton_basic__UYrxM","LogoutButton_external":"LogoutButton_LogoutButton_external__BwSis"};